import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Calendar } from 'react-date-range';  // 修改這行
import 'react-date-range/dist/styles.css';    // 新增這行
import 'react-date-range/dist/theme/default.css'; // 新增這行
import TTable from '../TTable';

const AbnormalGPSPanel = ({
    getabnormalGPSVehicle,
    setabnormalGPSdate,
    abnormalGPSdate,
    abnormalGPSVehiclelist,
    abnormalGPSheadCells,
    TWLocale
}) => (
    <Grid container spacing={2}>
        <Grid item xs={4}>
            <Typography variant="h5" gutterBottom component="div">
                選擇欲察看日期
            </Typography>
            <Calendar
                onChange={async (item) => {
                    await getabnormalGPSVehicle(item);
                    await setabnormalGPSdate(item);
                }}
                locale={TWLocale}
                date={abnormalGPSdate}
            />
        </Grid>
        <Grid item xs={8}>
            <TTable
                Vehiclelist={abnormalGPSVehiclelist}
                headCells={abnormalGPSheadCells}
            />
        </Grid>
    </Grid>
);

export default AbnormalGPSPanel;